module.exports = "../../static/img/video_title.999e53d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/video/video_title.png
// module id = 366v
// module chunks = 1